import type { GetContactsApiResponseTransformed } from '~services/api/bots';
import {
	formatBotPaymentOptions,
	isShowPaid,
	transformMessagePaymentType,
} from '~utils/payments';

import type { MappedDialogParticipant } from './types';

export const mapParticipants = (
	bots: GetContactsApiResponseTransformed['contacts'] = {},
	hasSubscription: boolean
): MappedDialogParticipant[] => {
	const result: MappedDialogParticipant[] = [];

	const botsArr = Object.values(bots);
	for (const bot of botsArr) {
		let paymentType: string[] = [];
		if (bot.lastMessage) {
			// TODO: At first senderId in history messages response data is backend way
			// then dispatching ws event senderId is client way
			const isBotMessage =
				Number(bot.lastMessage.senderId) === bot.serverId ||
				Number(bot.lastMessage.senderId) === bot.clientId;
			const { tarifficationType, cost, paid } = bot.lastMessage;
			paymentType = transformMessagePaymentType({
				type: tarifficationType,
				cost,
				isPaid: paid,
				isOwnMessage: !isBotMessage,
			});
		}

		const showPaid = isShowPaid(
			paymentType,
			bot.lastMessage?.cost ?? 0,
			hasSubscription,
			bot.lastMessage?.paid ?? true
		);

		const { options, paymentOptionTypes } = formatBotPaymentOptions(
			bot.preConditions
		);
		const paymentOptionText =
			paymentOptionTypes && paymentOptionTypes.length > 0
				? options[paymentOptionTypes[0]].textPurchaseInitial
				: undefined;

		const paymentOptionLevel =
			bot.preConditions?.paymentOptions.find(
				(option) => option.type === 'level'
			)?.value || 0;

		let promoPriority = 0;
		let sortingGroup: MappedDialogParticipant['sortingGroup'] = 20;
		let disabledByLevel = false;

		if (bot.accountType === 'influencer') {
			promoPriority = bot.promo?.priority || 0;
			sortingGroup = 10;
		} else if (bot.preConditions && bot.lastMessage === null) {
			sortingGroup = 30;
			disabledByLevel = true;
		}

		result.push({
			clientId: bot.clientId,
			name: bot.name,
			avatar: bot.images?.chatAvatarLinks,
			avatarFallback: bot.images?.chatAvatarPath,
			accountType: bot.accountType,
			tags: bot.tags,
			lastMessage: bot.lastMessage,
			unreadCount: bot.unreadMessagesCount,
			totalCount: bot.totalMessagesCount,
			visibility: bot.visibility,
			showPaid,
			paymentOptionText,
			paymentOptionLevel,
			promoPriority,
			sortingGroup,
			disabledByLevel,
			isTyping: bot.isTyping,
		});
	}

	return result;
};
